import React, { useState, useContext } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AziendeBuyer from './pages/AziendeBuyer';
import AziendeBuyerDettagli from './pages/AziendeBuyerDettagli';
import AziendeBuyerValutazioni from './pages/AziendeBuyerValutazioni';
import AziendeSeller from './pages/AziendeSeller';
import AziendeSellerDettagli from './pages/AziendeSellerDettagli';
import Date from './pages/Date';
import DateDettagli from './pages/DateDettagli';
import DateOre from './pages/DateOre';
import DateOreDettagli from './pages/DateOreDettagli';
import Impostazioni from './pages/Impostazioni';
import ImpostazioniDettagli from './pages/ImpostazioniDettagli';
import Macroregioni from './pages/Macroregioni';
import MacroregioniDettagli from './pages/MacroregioniDettagli';
import RiepilogoAppuntamentiBuyer from './pages/RiepilogoAppuntamentiBuyer';
import RiepilogoAppuntamentiSeller from './pages/RiepilogoAppuntamentiSeller';
import StampaAgendeBuyer from './pages/StampaAgendeBuyer';
import StampaAgendeSeller from './pages/StampaAgendeSeller';
import TipologieAziendeBuyer from './pages/TipologieAziendeBuyer';
import TipologieAziendeBuyerDettagli from './pages/TipologieAziendeBuyerDettagli';
import TipologieAziendeSeller from './pages/TipologieAziendeSeller';
import TipologieAziendeSellerDettagli from './pages/TipologieAziendeSellerDettagli';
import NotFound from './pages/NotFound';

export const AuthenticationContext = React.createContext(null);

function App() {

    const [authenticationToken, setAuthenticationToken] = useState(localStorage.getItem("adminAuthenticationToken"));

    if (!authenticationToken) {
        return (
            <>
                <div className="wrapper">
                    <AuthenticationContext.Provider value={{ authenticationToken: authenticationToken, setAuthenticationToken: setAuthenticationToken }}>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<Login></Login>}>
                                </Route>
                                <Route path="*" element={<NotFound />}>
                                </Route>
                            </Routes>
                        </BrowserRouter>
                    </AuthenticationContext.Provider>
                </div>
            </>
        );
    }

    return (
        <div className="wrapper">
            <AuthenticationContext.Provider value={{ authenticationToken: authenticationToken, setAuthenticationToken: setAuthenticationToken }}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Dashboard />}>
                        </Route>
                        <Route path="/aziendebuyer" element={<AziendeBuyer />}>
                        </Route>
                        <Route path="/aziendebuyer/:id" element={<AziendeBuyerDettagli />}>
                        </Route>
                        <Route path="/aziendebuyervalutazioni/:id" element={<AziendeBuyerValutazioni />}>
                        </Route>
                        <Route path="/aziendeseller" element={<AziendeSeller />}>
                        </Route>
                        <Route path="/aziendeseller/:id" element={<AziendeSellerDettagli />}>
                        </Route>
                        <Route path="/date" element={<Date />}>
                        </Route>
                        <Route path="/date/:id" element={<DateDettagli />}>
                        </Route>
                        <Route path="/dateore" element={<DateOre />}>
                        </Route>
                        <Route path="/dateore/:id" element={<DateOreDettagli />}>
                        </Route>
                        <Route path="/impostazioni" element={<Impostazioni />}>
                        </Route>
                        <Route path="/impostazioni/:id" element={<ImpostazioniDettagli />}>
                        </Route>
                        <Route path="/macroregioni" element={<Macroregioni />}>
                        </Route>
                        <Route path="/macroregioni/:id" element={<MacroregioniDettagli />}>
                        </Route>
                        <Route path="/riepilogoappuntamentibuyer" element={<RiepilogoAppuntamentiBuyer />}>
                        </Route>
                        <Route path="/riepilogoappuntamentiseller" element={<RiepilogoAppuntamentiSeller />}>
                        </Route>
                        <Route path="/stampaagendebuyer" element={<StampaAgendeBuyer />}>
                        </Route>
                        <Route path="/stampaagendeseller" element={<StampaAgendeSeller />}>
                        </Route>
                        <Route path="/tipologieaziendebuyer" element={<TipologieAziendeBuyer />}>
                        </Route>
                        <Route path="/tipologieaziendebuyer/:id" element={<TipologieAziendeBuyerDettagli />}>
                        </Route>
                        <Route path="/tipologieaziendeseller" element={<TipologieAziendeSeller />}>
                        </Route>
                        <Route path="/tipologieaziendeseller/:id" element={<TipologieAziendeSellerDettagli />}>
                        </Route>
                        <Route path="*" element={<NotFound />}>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthenticationContext.Provider>
        </div>
    );

}

export default App;
